import {Mapper} from '@s-ui/domain'

export class FromModelsJsonToSubscriptionModelsListVOVehiclesMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.subscriptionModelsListValueObjectFactory
   * */
  constructor({
    config,
    makeEntityFactory,
    modelEntityFactory,
    subscriptionModelsListValueObjectFactory,
    subscriptionModelValueObjectFactory
  }) {
    super()
    this._config = config
    this._makeEntityFactory = makeEntityFactory
    this._modelEntityFactory = modelEntityFactory
    this._subscriptionModelsListValueObjectFactory = subscriptionModelsListValueObjectFactory
    this._subscriptionModelValueObjectFactory = subscriptionModelValueObjectFactory
  }

  map = ({models = []}) => {
    const modelsList = models.map(model => {
      const {
        make: {id: makeId},
        model: {id: modelId, name, slug}
      } = model

      const makeEntity = this._makeEntityFactory({id: makeId})
      const modelEntity = this._modelEntityFactory({id: modelId, name, slug})

      return this._subscriptionModelValueObjectFactory({
        make: makeEntity,
        model: modelEntity
      })
    })
    return this._subscriptionModelsListValueObjectFactory({items: modelsList})
  }
}
